import { render, staticRenderFns } from "./CardLiveEvent.vue?vue&type=template&id=43bb24e8&scoped=true"
import script from "./CardLiveEvent.js?vue&type=script&lang=js&external"
export * from "./CardLiveEvent.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bb24e8",
  null
  
)

export default component.exports